export default "https://d1e6s5z4lzmgxx.cloudfront.net/9448f7a6-2ffc-48da-926d-72a27a448f00/images/muze-bg.png?a30d6d596e75337df8c462fcae4dde10";